<template>
  <div>
    <label >{{ $t('insights.ui.timespan.options') }}</label>
    <div class="custom-control custom-checkbox">
      <input v-model="config.includeWeekends"
             :value="true"
             @change=emitConfig
             type="checkbox"
             :id="'include-weekends_' + uniqueId"
             class="custom-control-input"
      />
      <label class="custom-control-label" :for="'include-weekends_' + uniqueId">
        <span>{{ $t('insights.ui.timespan.includeWeekends') }}</span>
      </label>
    </div>
    <div class="custom-control custom-checkbox">
      <input v-model="config.includeDutchHolidays"
             :value="true"
             @change=emitConfig
             type="checkbox"
             :id="'include-dutch-holidays_' + uniqueId"
             class="custom-control-input"
      />
      <label class="custom-control-label" :for="'include-dutch-holidays_' + uniqueId">
        <span>{{ $t('insights.ui.timespan.includeDutchHolidays') }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";
import {mapGetters} from "vuex";

export default {
  mixins: [generalMethods],
  name: "IncludeWeekends",
  props: ['editing', 'currentConfig'],
  data() {
    return {
      uniqueId: _.uniqueId()
    }
  },
  computed: {
    ...mapGetters('company', [
      'getActivities'
    ]),
  },
  created(){
    this.config = this.currentConfig
  }

}
</script>

<style scoped>

</style>